import React from 'react';
import styled from 'styled-components';
import { Emoji } from 'emoji-mart'
import { useLocation } from 'react-router-dom';

import { Button, Spinner } from 'components';

import { clientContext } from 'context';

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--primary-color);
    position: absolute;
    top: 0;
    left: 0;
`

const Modal = styled.div`
    background-color: var(--secondary-color);
    border: 1px solid var(--primary-accent-color);
    border-radius: 5px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const Icon = styled.img`
    height: 5rem;
    width: 5rem;
    object-fit: contain;
    src: ${props => props.icon};
    margin: 0 0.5rem 0 0;
    border-radius: 5px;
    background: var(--secondary-color);
    margin-bottom: 1rem;
`


const Title = styled.div`
    font-weight: bold;
    font-size: 1.3rem;
    margin-bottom: 0.5rem;
`

const Subtitle = styled.div`
    /* font-weight: bold; */
    font-size: 0.9rem;
    max-width: 80%;
    text-align: center;
    margin-bottom: 1rem;
`

const RedirectionScreen = props => {
    const {
        // value
    } = props;
    let location = useLocation();
    console.log({location: location, params: props.match.params})

    const value = props.match.params.id.toUpperCase()
    const client = clientContext[value]
    const icon = client['icon']
    const title = client['title']
    const outcome = location['search'].includes('success=true') ? 'success' : 'failed'
    const subtitle = client['redirectionMsg'][outcome]
    
    React.useEffect(() => {
        setTimeout(() => {
            console.log('Close window')
            window.close()
        }, 3000)
    }, [])

    console.log('REDIRECTION SCREEN')

    return(
        <Container>
            <Modal>
                {!icon ? null
                : icon['type'] === 'link' ? <Icon src={icon['value']}/>
                : icon['type'] === 'emoji' ? <div style={{margin: '0 0.5rem 0 0'}}><Emoji emoji={icon['value']} size={'1rem'}/></div>
                : icon['type'] === 'element' ? <div style={{margin: '0 0.5rem 0 0', height: '1rem', width: '1rem'}}>{icon['value']}</div>
                : null}
                <Title>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
                <Spinner styles={{color: 'var(--focus-color)'}}/>
            </Modal>
        </Container>
    )
}

export default RedirectionScreen


